import { useView } from '@10000/react'
import { Table } from './table'

export const InvoiceTable = () => {
  const { invoices } = useView('tenant')

  const columns = [
    { key: 'invoice', name: 'Invoice' },
    { key: 'number', name: 'Number' },
    { key: 'created', name: 'Created' },
    { key: 'amount', name: 'Amount' },
    { key: 'status', name: 'Status' },
    { key: 'pdf', name: 'PDF' },
  ]

  const rows = invoices.map(({ stripeInvoice, number, createdAt, amount, status, invoice_pdf }) => ({
    invoice: stripeInvoice,
    number,
    created: createdAt,
    amount,
    status,
    pdf: invoice_pdf
  }))

  return (
    <Table
      title="Invoices"
      rows={rows}
      columns={columns}
      defaultSortColumn="created"
    />
  )
}